
    import { Mapper } from "../../../../base/utils/mapper";
    import { BackgroundNeuropsychologyResponseModel } from "../../../../domain/models/consult/background-neuropsychology-response.model";
    import { BackgroundNeuropsychologyResponseEntity } from "../entities/background-neuropsychology-response.entity";
    
    export class BackgroundNeuropsychologyImplementationRepositoryMapper extends Mapper<BackgroundNeuropsychologyResponseEntity, BackgroundNeuropsychologyResponseModel>{
        mapFrom(param:  BackgroundNeuropsychologyResponseEntity):  BackgroundNeuropsychologyResponseModel { 
            return {
                data:param.data,
                isSuccess:param.isSuccess,
                message:param.message,
                errors:param.errors
            }; 
        }
        mapTo(param:  BackgroundNeuropsychologyResponseModel):  BackgroundNeuropsychologyResponseEntity {
            return {
                data:param.data,
                isSuccess:param.isSuccess,
                message:param.message,
                errors:param.errors 
            };
        }
    }